import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api-service';
import { HttpClient } from '@angular/common/http';
import { Meta, MetaDefinition, Title } from '@angular/platform-browser';
import { ReportConfig } from 'app/components/new-navigation/high-risk-registry/REPORT_CONFIG';

@Injectable({
  providedIn: 'root'
})
export class HighRiskRegistryService extends BaseApiService {
  dataCache: any;

  constructor(
    private http: HttpClient,
    private titleService: Title,
    private metaService: Meta
  ) {
    super();
    this.dataCache = {};
  }

  setPageDocumentMeta(reportConfig: ReportConfig): void {
    if (reportConfig) {
      this.titleService.setTitle(reportConfig.pageTitle);
      const tag: MetaDefinition = {
        name: 'description',
        content: reportConfig.pageMeta || reportConfig.subHeading
      };
      this.metaService.updateTag(tag);
    }
  }

  public getRankingsData(
    reportId: string,
    start,
    limit,
    additionalQueryString: string
  ) {
    return new Promise(resolve => {
      let url =
        `${this.getRatingsBaseUrl(
          '2020'
        )}/getHighRiskRankings?reportId=${reportId}` +
        `&${additionalQueryString}&start=${start}&limit=${limit}`;

      if (this.dataCache[url]) {
        setTimeout(() => {
          const cacheData = this.dataCache[url];
          resolve(JSON.parse(JSON.stringify(cacheData)));
        }, 300);
      } else {
        this.http.get(url).subscribe(res => {
          this.storeCache(res, this.dataCache, url);
          resolve(res);
        });
      }
    });
  }

  public getLastUpdated() {
    return new Promise(resolve => {
      let url = `${this.getRatingsBaseUrl(
        '2020'
      )}/getHighRiskRankings?reportId=highRiskLastUpdatedDate`;
      this.http.get(url).subscribe(response => {
        resolve(response);
      });
    });
  }

  public downloadCsv(reportId: string) {
    return new Promise(resolve => {
      const url = `${this.getRatingsBaseUrl()}/getExportUri?reportId=${reportId}&clientId=pixalate`;
      this.http
        .get(url, { headers: { 'skip-auth': 'true' } })
        .subscribe(response => {
          // skip-auth hack to skip adding authorization bearer
          resolve(response);
        });
    });
  }
}
